import React, { useRef } from "react"

import classes from "./PinCodeInput.module.scss"

const array = ["", "", "", "", ""]

const PinCodeInput = props => {
  const { onChange, onFinished, value } = props

  const inputRefs = useRef([])

  const replaceAt = (string, replacement, index) => (
    `${string.substring(0, index)}${replacement || " "}${string.substring(index + 1)}`
  )

  const validate = pincode => {
    if (String(pincode).length !== 5) return false

    if (isNaN(pincode)) return false

    if (String(pincode).includes(".")) return false

    return true
  }

  const handlePaste = (e) => {
    let pastedText
    if (window.clipboardData && window.clipboardData.getData) {
      pastedText = window.clipboardData.getData("Text")
    } else if (e.clipboardData && e.clipboardData.getData) {
      pastedText = e.clipboardData.getData("text/plain")
    }

    if (!validate(pastedText)) return e.preventDefault()

    onChange(pastedText)
    inputRefs.current[4].blur()
    onFinished(Number(pastedText))
  }

  const handleChange = (pin, index) => {
    if (index === 0 && validate(pin)) {
      onChange(pin)
      inputRefs.current[4].blur()
      onFinished(Number(pin))

      return
    }

    if (String(pin).length > 1) return

    const newValue = replaceAt(value, pin, index)
    onChange(newValue)

    if (newValue.length === 5) {
      inputRefs.current[index].blur()
      return onFinished(Number(newValue))
    }

    pin !== "" && inputRefs.current[index + 1].focus()
  }

  return (
    <div className={classes["codes"]}>
      {array.map((_, i) =>
        <input
          key={i}
          min={0}
          max={9}
          maxLength={1}
          onFocus={() => inputRefs.current[i].select()}
          type="number"
          className={classes["code"]}
          onPaste={handlePaste}
          value={value[i] || ""}
          ref={ref => inputRefs.current[i] = ref}
          onChange={e => handleChange(e.target.value, i)}
        />
      )}
    </div>
  )
}

export default PinCodeInput